/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/executor/components/ExecutorWorkspaceKpiBar.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Executor Workspace
 *
 * DESCRIPTION:
 * Displays operational KPI cards for Executor Workspace.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Display KPI summary
 * ✓ Handle KPI click
 * ✓ Highlight active KPI
 * ✓ Responsive Layout
 *
 ******************************************************************************/

import React from "react";

// ============================================================================
// KPI CONFIGURATION
// ============================================================================

const KPI_CONFIG = [

    {
        key: "assigned",
        title: "Assigned",
        icon: "fas fa-user-check",
        gradient: "linear-gradient(135deg,#0d6efd,#4f8cff)",
        filterValue: "ASSIGNED",
    },

    {
        key: "accepted",
        title: "Accepted",
        icon: "fas fa-handshake",
        gradient: "linear-gradient(135deg,#20c997,#0f766e)",
        filterValue: "ACCEPTED",
    },

    {
        key: "inProgress",
        title: "In Progress",
        icon: "fas fa-spinner",
        gradient: "linear-gradient(135deg,#fd7e14,#f59e0b)",
        filterValue: "IN_PROGRESS",
    },

    {
        key: "dueToday",
        title: "Due Today",
        icon: "fas fa-calendar-day",
        gradient: "linear-gradient(135deg,#ffc107,#f59e0b)",
        filterValue: "DUE_TODAY",
    },

    {
        key: "overdue",
        title: "Overdue",
        icon: "fas fa-exclamation-circle",
        gradient: "linear-gradient(135deg,#dc3545,#b91c1c)",
        filterValue: "OVERDUE",
    },

    {
        key: "pendingApproval",
        title: "Pending Approval",
        icon: "fas fa-user-clock",
        gradient: "linear-gradient(135deg,#6f42c1,#7c3aed)",
        filterValue: "PENDING_APPROVAL",
    },

    {
        key: "completedToday",
        title: "Completed Today",
        icon: "fas fa-check-circle",
        gradient: "linear-gradient(135deg,#198754,#16a34a)",
        filterValue: "COMPLETED_TODAY",
    },

];

// ============================================================================
// COMPONENT
// ============================================================================

export default function ExecutorWorkspaceKpiBar({

    summary = {},

    activeFilter = "",

    onSelect,

}) {

    return (

        <div className="row mb-4">

            {KPI_CONFIG.map((item) => (

                <div
                    key={item.key}
                    className="col-xl col-lg-3 col-md-4 col-sm-6 mb-3"
                >

                    <div

                        className="card border-0 shadow-sm h-100"

                        role="button"

                        onClick={() => {

                            if (onSelect) {

                                onSelect(item.filterValue);

                            }

                        }}

                        style={{

                            cursor: "pointer",

                            background: item.gradient,

                            color: "#fff",

                            borderRadius: "12px",

                            transform:

                                activeFilter === item.filterValue

                                    ? "scale(1.03)"

                                    : "scale(1)",

                            transition: "all .20s ease",

                        }}

                    >

                        <div className="card-body">

                            <div className="d-flex justify-content-between align-items-start">

                                <div>

                                    <div
                                        className="small"
                                        style={{
                                            opacity: .9,
                                        }}
                                    >

                                        {item.title}

                                    </div>

                                    <h2 className="fw-bold mb-0 mt-2">

                                        {summary[item.key] || 0}

                                    </h2>

                                </div>

                                <div>

                                    <i

                                        className={item.icon}

                                        style={{

                                            fontSize: 28,

                                            opacity: .90,

                                        }}

                                    />

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            ))}

        </div>

    );

}